import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {dismissFlowSuccess} from "../../../../widget/misc/WidgetUtils";
import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {HappyFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {userService} from "../../../../../client/connection/Services";
import {SubscriptionCoveragePerk} from "../subscribe/components/CoverageDescriptionElements";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {iFrameState} from "../../../../services/IFrameState";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {PromptManageAccountButton} from "../../../panel-elements/LoginFooter.jsx";


export class DonationSuccessPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        marginBottom: 14,
        textAlign: "center",
        display: "block"
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(DonationSuccessPanelStyle)
export class DonationSuccessPanel extends BasePanelPage {
    getMessageTop() {
        const donation = iFrameUserDataService.getLatestDonation();
        const merchantName = iFrameMerchantService.getMerchant().getName();
        const email = userService.getUserEmail();

        if (donation.isRecurring()) {
            return Messages.donateThankYouMessageRecurring(merchantName, email)
        }
        return Messages.donateThankYouMessageOneTime(merchantName, email);
    }

    getMessageTitle() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (donation.isRecurring()) {
            return Messages.donateThankYouTitleRecurring(donation.formatPrice());
        }
        return Messages.donateThankYouTitleOneTime(donation.formatPrice());
    }

    getGuidelines() {
        const donation = iFrameUserDataService.getLatestDonation();

        if (iFrameState.forceHideWallet) {
            return null;
        }

        if (donation.isRecurring()) {
            return [
                <SubscriptionCoveragePerk text={Messages.donateThankYouRecurringGuideline1}/>,
                <SubscriptionCoveragePerk text={Messages.donateThankYouRecurringGuideline2}/>,
            ];
        }
        return [
            <SubscriptionCoveragePerk text={Messages.donateThankYouOneTimeGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.donateThankYouOneTimeGuideline2}/>,
        ];
    }

    render() {
        const {styleSheet} = this;

        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <HappyFaceIcon size={62} className={styleSheet.icon}/>,
            <MessageElement
                className={styleSheet.title}
                message={this.getMessageTitle()}
            />,
            <MessageElement
                className={styleSheet.message}
                message={this.getMessageTop()}
            />,
            <div className={styleSheet.message}>
                {Messages.donateThankYouBottomMessage}
            </div>,
            this.getGuidelines(),
            <MerchantButton className={styleSheet.actionButton} onClick={dismissFlowSuccess}>
                {Messages.ok}
            </MerchantButton>,
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <PromptManageAccountButton className={styleSheet.backButton} />,
        ];
    }
}
